// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.contact-intro {
  font-size: 1rem;
  color: #555;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2rem;
  align-items: start;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.contact-item {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #e0e0e0;
}

.contact-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.contact-item h3 {
  color: #1a1a2e;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.contact-link {
  color: #4ecca3;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  transition: color 0.3s ease;
  display: inline-block;
}

.contact-link:hover {
  color: #3db88a;
  text-decoration: underline;
}

.contact-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
}

.wechat-qr-container {
  width: 200px;
  height: 200px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.wechat-qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .contact-content {
    padding: 1.5rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .contact-info {
    gap: 1rem;
  }

  .contact-item {
    padding-bottom: 1rem;
  }

  .wechat-qr-container {
    width: 180px;
    height: 180px;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".contact-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.contact-intro {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n}\n\n.contact-grid {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 2rem;\n  align-items: start;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.contact-item {\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.contact-item:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.contact-item h3 {\n  color: #1a1a2e;\n  font-size: 1.125rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.contact-link {\n  color: #4ecca3;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n  display: inline-block;\n}\n\n.contact-link:hover {\n  color: #3db88a;\n  text-decoration: underline;\n}\n\n.contact-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.wechat-qr-container {\n  width: 200px;\n  height: 200px;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.wechat-qr-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@media (max-width: 768px) {\n  .contact-content {\n    padding: 1.5rem;\n  }\n\n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .contact-info {\n    gap: 1rem;\n  }\n\n  .contact-item {\n    padding-bottom: 1rem;\n  }\n\n  .wechat-qr-container {\n    width: 180px;\n    height: 180px;\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
